export default __webpack_public_path__ + "media/images/portrait/small/avatar-s-20-8e42aea3d094951313c3bb1f7f180a57.png";